import React from 'react';
import styles from './radio-button.module.scss';
import useAccessibleClick from '../../../../../common/hooks/useAccessibleClick';
import { useTranslation } from 'react-i18next';

const RadioButton = ({ id, checked, onChange, ariaLabel = '' }) => {
  const ref = useAccessibleClick(onChange)
  const { t } = useTranslation();

  return (
    <label id={id} tabIndex={0} ref={ref} className={styles.label} aria-label={`${t('general.select')} ${ariaLabel}`}>
      <input type="radio" id={id} className={styles.radio} checked={checked} onClick={e => onChange(e)} />
      <span className={styles.fake} />
    </label>
  );
};

export default RadioButton;
